module.exports = __webpack_public_path__ + "static/Science of Evidence-a20bb1356a93bbce26ec6a17a39ffec5.jpg";